module.exports = __webpack_public_path__ + "media/images/apple-touch-icon-c3542d53db4243a1288e114b382b60dc.png";